import { render, staticRenderFns } from "./MainContents.vue?vue&type=template&id=c7201ba0&scoped=true"
import script from "./MainContents.vue?vue&type=script&lang=js"
export * from "./MainContents.vue?vue&type=script&lang=js"
import style0 from "./MainContents.vue?vue&type=style&index=0&id=c7201ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7201ba0",
  null
  
)

export default component.exports